<template>
  <div v-if="show" :class="`quick-access col-lg-${options.colSize || 6}`">
    <b-modal v-if="authorization"
      v-model="declineModal"
      title="Recusar Acesso"
      class="modal-primary"
      @ok="decline">

      Deseja realmente negar o acesso ao usuário {{ authorization.user.email }} ao sistema?<br>
      O usuário será removido e deverá se cadastrar novamente.
    </b-modal>

    <list-groups :options="options" >
      <span slot="action" class="label label-success">
        {{ pagination.total }}
      </span>

      <template slot="card" v-if="collection.length > 0">
        <b-list-group-item v-for="(item, index) in collection"
          :key="`card-authorizaitons-${index}`"
          :route="options.route"
          :href="href(item)"
          target="_self"
          class="flex-column align-items-start quick-access">

          <b-row>
            <b-col sm="8">
              <h5>
                {{ item.user.name }}&nbsp;
                ({{ item.user.main_role ? item.user.main_role.name : '' }})
              </h5>
              <span>
                {{ item.user.email || '' }} {{ item.user.document || '' }}
              </span>
            </b-col>
            <b-col>
              <div class="actions d-flex w-100 justify-content-end">
                <b-button variant="success"
                  @click.stop="approve(item)"
                  :disabled="processingAuthorizations.indexOf(item.id) > -1">

                  <i class="fa fa-check"></i> Aprovar
                </b-button>
                <b-button variant="secondary"
                  @click.stop="showDeclineModal(item)"
                  :disabled="processingAuthorizations.indexOf(item.id) > -1">
                  <i class="fa fa-times"></i> Recusar
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-list-group-item>
      </template>

      <b-list-group-item v-else slot="card">
        <b-row>
          <b-col>
            <div class="actions d-flex w-100 justify-content-center">
              Nenhuma autorização pendente foi encontrada
            </div>
          </b-col>
        </b-row>
      </b-list-group-item>

      <div slot="footer">
        <router-link :to="{ name: 'bl-authorizations.index' }">
          <small class="btn pull-right">
            Visualizar todas
          </small>
        </router-link>
      </div>
    </list-groups>
</div>
</template>

<script>
import Authorizations from '@/services/api/bl-authorizations'

export default {
  name: 'widget-system-user',
  data () {
    return {
      show: false,
      authorization: null,
      declineModal: false,
      processingAuthorizations: [],

      collection: [],
      pagination: [],
      fields: [
        { key: 'user', label: 'Usuário' },
        { key: 'role', label: 'Perfil' },
        { key: 'created_at', label: 'Data de criação' },
        { key: 'actions', label: 'Ações' }
      ],

      options: {
        name: 'Autorizações de Acesso Pendentes',
        caption: '',
        icon: 'fa fa-lock',
        colSize: 12,
        entity: {
          url: '/bl/authorizations',
          params: {
            with: ['user.roles'],
            _search: { status: 0 },
            per_page: 5
          }
        },

        route: {
          name: 'bl-authorizations.index'
        },

        link: false
      }
    }
  },

  computed: {
    //
  },

  methods: {
    href (item) {
      if (this.options.link) {
        return this.options.link.href + item.id || '#!'
      }

      return null
    },

    approve (authorization) {
      const self = this

      self.$Progress.start()
      self.processingAuthorizations.push(authorization.id)
      return Authorizations.approve(authorization)
        .then((res) => {
          let index = self.processingAuthorizations.indexOf(authorization.id)

          if (index > -1) {
            self.processingAuthorizations.splice(index, 1)
          }

          self.$Progress.finish()
          self.$toasted.success('Usuário autorizado com sucesso')
          self.refresh()
        })
    },

    showDeclineModal (authorization) {
      this.authorization = authorization
      this.declineModal = true
    },

    decline () {
      const self = this

      self.declineModal = false
      self.$Progress.start()

      Authorizations.decline(self.authorization)
        .then((res) => {
          self.$Progress.finish()
          self.$toasted.success('Autorização negada e o usuário foi removido.')
          self.refresh()
          self.authorization = null
        })
    },

    refresh () {
      let self = this

      Authorizations.index({
        params: self.options.entity.params
      }).then(function (res) {
        self.show = res.data.collection.length > 0
        self.collection = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },

  created () {
    this.refresh()
  }
}
</script>

<style lang="sass" scoped>
  .actions
    .btn
      font-weight: normal;
      font-size: 13px;


  .card-actions
      .label
        padding: 5px 10px;
        border-radius: 2px;

</style>



// WEBPACK FOOTER //
// src/components/widgets/Bl/Authorizations.vue